import { getFirestore, doc, getDoc } from "firebase/firestore";
import { app } from "./firebaseConfig"; // Use named export

const db = getFirestore(app);

export const getUserRole = async (uid) => {
  try {
    const userRef = doc(db, "users", uid);
    const userDoc = await getDoc(userRef);
    if (userDoc.exists()) {
      return userDoc.data().role;
    } else {
      throw new Error("No such user!");
    }
  } catch (error) {
    console.error("Error fetching user role:", error.message);
    throw error;
  }
};
